/* popup-email-fix.js - PL 2026-10-10
   Small companion to popup-system.js. Loaded deferred from
   snippets/gtm-head.liquid. Does nothing on pages without the popup.

   Why: GA4 (12 Sep - 9 Oct) showed 106 people hit an email validation
   error against 409 successful email submits, and the quiz unit lost 88%
   of people between picking a goal (870) and submitting an email (101).

   What it does:
   1. Repairs obvious email slips before popup-system.js validates:
      stray spaces, comma for dot, trailing dot, mailto: pastes, full-width
      @ and . from some mobile keyboards, double dots, uppercase domain.
   2. When an email is still invalid, shows a clearer message for an empty
      field and adds plps_reason (empty / no_at / bad_domain / format) to
      the existing plps_validation_error event, so GA4's Popup Error
      Reason dimension says why people fail.
   3. Pushes plps_field_input the first time someone types in a popup
      email or phone field, separating "saw the step and left" from
      "started typing and left".

   It listens on document in the capture phase, so it runs before the
   popup's own submit handler on the modal. Valid submits pass straight
   through to popup-system.js unchanged. Theme editor is skipped. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  var preview = /[?&]pl_popup=/.test(location.search);

  function cleanEmail(v) {
    var s = String(v || '');
    s = s.replace(/^mailto:/i, '');
    s = s.replace(/＠/g, '@').replace(/．/g, '.');
    s = s.replace(/\s+/g, '');
    s = s.replace(/,/g, '.');
    s = s.replace(/\.+$/, '');
    s = s.replace(/\.{2,}/g, '.');
    var at = s.lastIndexOf('@');
    if (at > 0) s = s.slice(0, at) + '@' + s.slice(at + 1).toLowerCase();
    return s;
  }

  function reasonFor(raw, cleaned) {
    if (!String(raw || '').trim()) return 'empty';
    if (cleaned.indexOf('@') === -1) return 'no_at';
    if (!/\.[a-z]{2,}$/i.test(cleaned.split('@').pop())) return 'bad_domain';
    return 'format';
  }

  function push(event, modal, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: event,
      plps_unit: (modal && modal.getAttribute('data-plps-unit-type')) || '',
      plps_preview: preview
    };
    if (extra) for (var k in extra) payload['plps_' + k] = extra[k];
    window.dataLayer.push(payload);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('.plps-modal form[data-plps-form="email"]')) return;
    var hp = form.querySelector('input[name="website"]');
    if (hp && hp.value) return; // let popup-system.js bot check handle it
    var input = form.querySelector('input[name="email"]');
    if (!input) return;
    var raw = input.value;
    var cleaned = cleanEmail(raw);
    if (cleaned !== raw) input.value = cleaned;
    if (EMAIL_RE.test(cleaned)) return; // valid: popup-system.js takes over

    /* Still invalid. Handle the error here instead of letting the popup do
       it, so the one plps_validation_error event carries the reason. */
    e.preventDefault();
    e.stopPropagation();
    var why = reasonFor(raw, cleaned);
    var box = form.querySelector('[data-plps-error]');
    input.setAttribute('aria-invalid', 'true');
    try { input.focus(); } catch (err) {}
    if (box) {
      box.hidden = false;
      box.textContent = why === 'empty'
        ? 'Add your email and we will send your code right over.'
        : 'That email address does not look right. Please check it and try again.';
    }
    push('plps_validation_error', form.closest('.plps-modal'), { field: 'email', reason: why });
  }, true);

  var typed = typeof WeakMap === 'function' ? new WeakMap() : null;
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || (t.name !== 'email' && t.name !== 'phone')) return;
    var modal = t.closest && t.closest('.plps-modal');
    if (!modal || !typed) return;
    var seen = typed.get(modal) || {};
    if (seen[t.name]) return;
    seen[t.name] = true;
    typed.set(modal, seen);
    push('plps_field_input', modal, { field: t.name });
  }, true);
})();

/* PL 2026-10-11 collage pause control (WCAG 2.2.2 Pause, Stop, Hide).
   The new visitor collage drifts continuously, so it must be pausable.
   One delegated listener: toggles .is-paused on the collage, keeps
   aria-pressed and the accessible name in sync, and logs the choice. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-plps-collage-toggle]');
    if (!btn) return;
    var box = btn.closest('[data-plps-collage]');
    if (!box) return;
    var paused = !box.classList.contains('is-paused');
    box.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play photo animation' : 'Pause photo animation');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'plps_collage_toggle', plps_state: paused ? 'paused' : 'playing' });
  });
})();
